import ArrayDSCode from "!!raw-loader!./datagrids/ArrayDS.tsx";
import ArrayDSWithListItemPatternCode from "!!raw-loader!./datagrids/ArrayDSWithListItemPattern";
import NodeDSCode from "!!raw-loader!./datagrids/NodeDS.tsx";
import EmptyDSCode from "!!raw-loader!./datagrids/EmptyDS.tsx";
import ErrorDSCode from "!!raw-loader!./datagrids/ErrorDS.tsx";
import { styled } from "@mui/material/styles";
import { grey } from "designSystem/styles/color";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import ArrayDS from "./datagrids/ArrayDS";
import NodeDS from "./datagrids/NodeDS";
import EmptyDS from "./datagrids/EmptyDS";
import ErrorDS from "./datagrids/ErrorDS";
import ArrayDSWithListItemPattern from "./datagrids/ArrayDSWithListItemPattern";

const PREFIX = "DataGrids";

const classes = {
	box: `${PREFIX}box`,
};

const Root = styled("div")(({
	theme,
}) => ({
	[`& .${classes.box}`]: {
		backgroundColor: grey[50],
		maxHeight: 400,
		width: "auto",
	},
}));

export default (props: PaneProps) => {
	const { box } = classes;
	const components: ComponentProps[] = [
		paneComponent("ArrayDataStore", ArrayDSCode, ArrayDS, null, box),
		paneComponent("ArrayDSWithListItemStore", ArrayDSWithListItemPatternCode, ArrayDSWithListItemPattern, null, box),
		paneComponent("NodeDataStore", NodeDSCode, NodeDS, "This demonstrates the use of the NewCardComponent to allow creation of new items", box),
		paneComponent("Empty", EmptyDSCode, EmptyDS, null, box),
		paneComponent("Error", ErrorDSCode, ErrorDS, null, box),
	];

	return (
		<Root>
			<Pane
				components={components}
				imports='import {DataGrid} from "designSystem/index";'
				{...props}
			/>
		</Root>
	);
};